import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLstStockHacienda = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'lst_planilla_corral', // Cambiar
        name: 'Listado Stock de Hacienda', // Cambiar
        component: ViewLstStockHacienda,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
